import { useMutation } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../hooks/useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../hooks/useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  apiV2Request,
} from "../../../hooks/api/v2/apiV2Request";

export type CollectionPickingListReference =
  | { type: "allocated"; id: number }
  | { type: "awaiting-confirmation"; date: string };

export const useSellarDownloadCollectionPickingList = () => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: ({
      reference,
      view,
    }: {
      reference: CollectionPickingListReference;
      view: "sku" | "order";
    }) => {
      const path =
        reference.type === "allocated"
          ? `sellar-distribution-collection/${reference.id}/download-picking-list`
          : `sellar-distribution-collection/awaiting-confirmation/${reference.date}/download-picking-list`;

      return apiV2Request({
        user,
        business,
        method: "GET",
        path: `${path}?view=${view}`,
      }).then((response) => apiV2AssertResponse<string>(response).data);
    },
  });
};
